import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getPriceToggleOn = (state: StoreApplicationState) => {
    return state.store.data.priceToggle.isPriceToggleOn;
};
